import { render, staticRenderFns } from "./ListCampaignsAffiliate.vue?vue&type=template&id=3a07072d"
import script from "./ListCampaignsAffiliate.vue?vue&type=script&lang=js"
export * from "./ListCampaignsAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable});
